module.exports = __webpack_public_path__ + "img/cyprus.43b836b.webp";